// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3IYOt","containerItemsCenter":"Skeleton_containerItemsCenter__1mGfu"};